"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOT_KEYWORDS = void 0;
exports.BOT_KEYWORDS = [
    'headless',
    'whitehat',
    'pinterest',
    'solarwinds',
    'google',
    'cloudfront',
    'amazon',
    'facebook',
    'bot',
    'security',
    'chromatic',
    'darwin',
    'cfnetwork',
    'spider',
    'crawl',
    'scrape',
    'archive',
    'monitor',
    'fetch',
    'validator',
    'checker',
    'index',
    'search',
    'scan',
    'http://bit.ly',
    'slurp',
    'pingdom',
    'wget',
    'curl',
    'python',
    'java',
    'httpclient',
    'libwww',
    'perl',
    'qualys',
    'bytespider',
    'gpt',
    'claude',
    'meta',
    'byte',
];
